<ng-container *transloco="let t; read: 'ivr-option-table-editor'">
  <div class="ivr-option-table-editor">
    <p-messages severity="info">
      <ng-template pTemplate>
        <div class="ml-2">
          {{ t('infoMessage') }}
        </div>
      </ng-template>
    </p-messages>

    <div class="ivr-option-table-editor__table-wrapper">
      <app-data-table
        [cols]="cols"
        [loading]="loading"
        [selectedCols]="cols"
        [tableRows]="tableRows$"
        [translationScope]="'ivr-option-table-editor'"
      >
        <ng-container appDataTableColumnDef="action">
          <th *appDataTableHeader>{{ t('colAction') }}</th>
          <td *appDataTableCell="let rowData" class="ivr-option-table-editor__actions">
            <button
              class="p-button-rounded p-button-primary p-button-text p-button-sm"
              pButton
              tooltipPosition="top"
              type="button"
              [attr.aria-label]="t('editTooltip')"
              [pTooltip]="t('editTooltip')"
              (click)="onEditOptionClicked(rowData)"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              class="p-button-rounded p-button-secondary p-button-text p-button-sm"
              pButton
              tooltipPosition="top"
              type="button"
              [attr.aria-label]="t('cloneTooltip')"
              [pTooltip]="t('cloneTooltip')"
              (click)="onCloneOptionClicked(rowData)"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
            <button
              class="p-button-rounded p-button-danger p-button-text p-button-sm"
              pButton
              tooltipPosition="top"
              type="button"
              [attr.aria-label]="t('deleteTooltip')"
              [pTooltip]="t('deleteTooltip')"
              (click)="onDeleteOptionClicked(rowData)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
      </app-data-table>
      <app-progress-spinner *ngIf="loading"></app-progress-spinner>
    </div>
  </div>
</ng-container>
